import { BackButton } from '@/components';
import { CameraTable } from '@/features/CameraTable';
import { useDocumentTitle } from '@/hooks';

export default function CamerasPage() {
    useDocumentTitle('cameras');

    return (
        <div className="h-full relative">
            <BackButton variant="floating" />
            <CameraTable />
        </div>
    );
}
